export enum PatientRelationship {
  PATIENT = 'patient',
  CAREGIVER = 'caregiver',
  FAMILY = 'family member',
  FRIEND = 'friend',
  PROVIDER = 'another care provider',
  INTERPRETER = 'interpreter',
  OTHER = 'other',
}
